import { ModelUtilisateur } from '../modules/fiscalite/types/optionFiscaleModel'

export const utilisateurEstMultiCompte = () => {
	const utilisateur: ModelUtilisateur = JSON.parse(localStorage.getItem('utilisateur') || '')
	const type = utilisateur.type ?? ''

	return type.toLowerCase() === 'indivision' || type.toLowerCase() === 'usufruit/nue-propriete' || type.toLowerCase() === 'compte joint de titres'
}